import React from "react";
import SurveysUI from "./components/SurveysUI";

const Main = () => {
  return <SurveysUI />;
};

export default Main;
